/**
 * The host page's OneTrust consent. `unavailable` (no OneTrust on the page, or not loaded in time) means
 * "no consent", never "consent not required"; `activeGroups` mirrors `window.OptanonActiveGroups`.
 */
export type HostConsentState = { status: 'unavailable' } | { status: 'ready'; activeGroups: string[] }

/** EXTERNAL: OneTrust writes the active groups as ",1,2,4,". */
export function parseOneTrustActiveGroups(value: unknown): string[] | null {
  if (typeof value !== 'string') return null
  return value
    .split(',')
    .map(group => group.trim())
    .filter(Boolean)
}
